import { schema } from 'normalizr';

export const cosAnnexeTRSchema = new schema.Entity('cosAnnexesTR', {}, { idAttribute: 'CosAnnexeTRId' });
export const cosAnnexeTRListSchema = [cosAnnexeTRSchema];
